{
  "overview": {
    "contactPreferences": {
      "emailNotAvailableReason": "E-post er ikke tilgjengelig. E-postadresse mangler",
      "smsNotAvailableReason": "SMS er ikke tilgjengelig. Telefonummer mangler.",
      "ehfNotAvailableReason": "EHF er ikke tilgjengelig. Skogeier har ikke organisasjonsnummer"
    },
    "propertyDocumentation": {
      "abortDialog": {
        "title": "Er du sikker på at du vil avbryte?",
        "description": "Endringer som er gjort, inkludert opplastede filer og beskrivelser, vil ikke bli lagret.",
        "actionLabel": "Avbryt uten å lagre",
        "cancelLabel": "Fortsett redigering"
      }
    },
    "communicationMethods": {
      "email": "E-post",
      "paper": "Brev"
    }
  },
  "history": {
    "history": "Historikk",
    "events": "Hendelser",
    "logDescription": "Historiske aktiviteter for denne skogeieren",
    "newestFirst": "Nyeste først",
    "oldestFirst": "Eldste først",
    "chooseTimeframe": "Velg periode",
    "loading": "Laster historiske hendelser...",
    "loadingError": "Kunne ikke laste historiske hendelser: {{message}}",
    "showAllTypes": "Vis alle typer",
    "ownerInfoLabel": "Skogeieropplysninger",
    "shareInfoLabel": "Andelsinformasjon",
    "noEventsFoundTitle": "Ingen hendelser funnet",
    "noEventsFoundPrefix": "Fant ingen hendelser ",
    "fromDateOnly": "fra ",
    "betweenDates": "mellom datoene ",
    "eventsPerPageLabel": "Hendelser per side",
    "emptyState": {
      "title": "Ingen hendelser",
      "description": "Det er ingen historiske aktiviteter på denne skogeieren"
    },
    "changeTypes": {
      "contact": "Kontaktopplysninger",
      "address": "Adresseopplysninger",
      "shareHistory": "Andelshistorikk"
    },
    "smsHistory": "SMS historikk",
    "smsDescription": "SMS-utsendelser til denne skogeieren",
    "sms": {
      "allSenders": "Alle avsendere",
      "loading": "Laster SMS-historikk...",
      "loadingError": "Feil ved lasting av SMS-historikk: {{message}}",
      "empty": {
        "title": "Ingen SMS utsendelser",
        "titleFiltered": "Ingen SMS utsendelser funnet",
        "description": {
          "none": "Det er ingen SMS utsendelser på denne skogeieren",
          "filtered": "Fant ingen SMS fra {{sender}} i valgt periode {{from}} - {{to}}.\nPrøv å justere filterne.",
          "fromDateOnly": "Fant ingen SMS fra {{from}}.\nPrøv å justere filterne.",
          "fromDateOnlyWithSender": "Fant ingen SMS fra {{sender}} fra {{from}}.\nPrøv å justere filterne.",
          "senderOnly": "Fant ingen SMS fra {{sender}}.\nPrøv å justere filterne."
        }
      },
      "paginationLabel": "SMS-utsendelser per side"
    }
  },
  "register": {
    "step0": {
      "fieldForestSharesOptionYes": "Ja, andelseier",
      "fieldForestSharesOptionYesDescription": "Skogeier ønsker å bli andelseier i Viken Skog",
      "fieldForestSharesOptionNo": "Nei, ikke andelseier",
      "fieldForestSharesOptionNoDescription": "Skogeier ønsker ikke å bli andelseier",
      "fieldForestSharesOptionUncertain": "Usikker, ønsker mer informasjon",
      "fieldForestSharesOptionUncertainDescription": "Viken Skog tar kontakt for mer informasjon senere",
      "fieldForestOwnerTypeOrganization": "Organisasjon",
      "fieldForestOwnerTypeOrganizationDescription": "Når skogeier er for eksempel et firma",
      "fieldForestOwnerTypeSameie": "Sameie",
      "fieldForestOwnerTypeSameieDescription": "Når skogeier er to eller flere personer eller juridiske enheter, som eier noe sammen. Gjelder ikke ektefeller, de må registreres som privat skogeier",
      "fieldForestOwnerTypePrivate": "Privat skogeier",
      "fieldForestOwnerTypePrivateDescription": "Når skogeier er en privatperson"
    },
    "step1": {
      "contactPreferenceEmail": "E-post",
      "contactPreferencePhone": "SMS",
      "contactPreferencePost": "Post (brev)"
    },
    "mailRecipient": {
      "forestOwner": "Skogeier",
      "representative": "Representant",
      "organization": "Organisasjon",
      "other": "Annen"
    }
  },
  "edit": {
    "mailRecipient": {
      "forestOwner": "Skogeier",
      "representative": "Representant",
      "other": "Annen"
    }
  },
  "type": {
    "private": "Privat",
    "partnership": "Sameie",
    "organization": "Organisasjon"
  }
}
